import type { AstApnTag } from "@omni/ads";
import type { Ad } from "../../../../types/ads/adResource";
import type { PlaceholderConfigs } from "../../../../types/injectables";

import { getApnTag } from ".";
import { astTagCreator } from "./astTagCreator";
import { batcher } from "./batcher";

const tagAndBatch = async (
  batchToLoad?: (Ad | PlaceholderConfigs)[],
  apnTag?: AstApnTag,
): Promise<void> => {
  if (
    typeof window === "undefined" ||
    !Array.isArray(batchToLoad) ||
    !batchToLoad.length
  ) {
    return;
  }
  const apntag = apnTag ? apnTag : await getApnTag();
  const tags = astTagCreator(batchToLoad);
  batcher(tags, apntag);
};

const tagAndLoadTakeover = async (
  takeoverResourceToLoad?: Ad,
  apnTag?: AstApnTag,
): Promise<void> => {
  if (typeof window === "undefined" || !takeoverResourceToLoad) {
    return;
  }
  const apntag = apnTag ? apnTag : await getApnTag();
  const tags = astTagCreator([takeoverResourceToLoad]);
  batcher(tags, apntag);
  return;
};

export { tagAndBatch, tagAndLoadTakeover };
